import { render } from "./DefaultSvgArrowRight.vue?vue&type=template&id=7739fa5f&scoped=true"
import script from "./DefaultSvgArrowRight.vue?vue&type=script&lang=js"
export * from "./DefaultSvgArrowRight.vue?vue&type=script&lang=js"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7739fa5f"]])

export default __exports__